import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { SlackConfigurationItem } from "./SlackConfigurationItem"

import type { SlackConfiguration } from "@/api/useIntegrations.types"
import type { SlackConfigurationTabProps } from "."

export const SlackConfigurationTab = (props: SlackConfigurationTabProps) => {
  const { t } = useTranslation()
  const [data] = useIntegration(props)
  const configuration = data?.configuration as SlackConfiguration | undefined
  const channels = configuration?.installations || []

  if (!channels.length) return <>{t("integrations.slack.noData")}</>

  return (
    <Flex vertical gap={8}>
      {channels.map((channel) => (
        <SlackConfigurationItem key={channel.id} channel={channel} {...props} />
      ))}
    </Flex>
  )
}
